// Rolling animation log (F4). A dev overlay that lists every clip the character
// plays, per layer, newest at the top — so we can watch the animation flow and
// talk about what to improve. Fed by animator.onAnim (see animator._rec).
const COLORS = { base: '#7ec27e', hold: '#6cc6d6', upper: '#e6b84a', full: '#d183d6' };
const LABEL = { base: 'BASE ', hold: 'HOLD ', upper: 'UPPER', full: 'FULL ' };

export class AnimLog {
  constructor() {
    this.open = false;
    this.rows = [];
    this.max = 22;
    this.lastT = null;
    this.el = document.createElement('div');
    this.el.id = 'animlog';
    this.el.style.cssText = `
      position: fixed; top: 150px; right: 10px; width: 300px; z-index: 9;
      font: 12px/1.35 'DejaVu Sans Mono', Consolas, monospace;
      color: #dfe2e6; background: rgba(12,14,18,0.72);
      border: 1px solid rgba(255,255,255,0.12); border-radius: 6px;
      padding: 7px 9px; pointer-events: none; display: none;
      white-space: nowrap; overflow: hidden;`;
    this.el.innerHTML = '<div style="opacity:.6;margin-bottom:4px">ANIM LOG — F4</div><div id="animlog-rows"></div>';
    document.body.appendChild(this.el);
    this.rowsEl = this.el.querySelector('#animlog-rows');
  }

  toggle() {
    this.open = !this.open;
    this.el.style.display = this.open ? 'block' : 'none';
  }

  push(e) {
    const dt = this.lastT == null ? 0 : e.t - this.lastT;
    this.lastT = e.t;
    const gap = dt >= 1000 ? `${(dt / 1000).toFixed(1)}s` : `${Math.round(dt)}ms`;
    const rate = e.rate !== 1 ? ` ×${e.rate}` : '';
    const row = `<div><span style="opacity:.45">+${gap.padStart(6)}</span> `
      + `<b style="color:${COLORS[e.layer] || '#fff'}">${LABEL[e.layer] || e.layer}</b> `
      + `<span>${e.name}${rate}</span></div>`;
    this.rows.unshift(row);
    if (this.rows.length > this.max) this.rows.length = this.max;
    // only touch the DOM while visible (zero cost when the panel is closed)
    if (this.open) this.rowsEl.innerHTML = this.rows.join('');
  }
}
